import Stack from '@mui/material/Stack'
import { HeatmapCell } from './HeatmapCell'
import { PlanUsageHeatmapMonthLabels } from './PlanUsageHeatmapMonthLabels'
import { PlanUsageHeatmapWeekdayAxis } from './PlanUsageHeatmapWeekdayAxis'

/** @param {{ columns: number[][] }} props */
export function PlanUsageActivityHeatmapGrid({ columns }) {
  return (
    <>
      <PlanUsageHeatmapMonthLabels />
      <Stack direction="row" justifyContent="center" alignItems="flex-start" gap="2px" role="img" aria-label="Weekly activity grid for the past year. Intensity runs from empty to dark green." sx={{ width: '100%', overflowX: 'auto', pb: 0.5, isolation: 'isolate' }}>
        <PlanUsageHeatmapWeekdayAxis />
        <Stack direction="row" gap="6px" sx={{ flexShrink: 0 }}>
          {columns.map((column, wi) => (
            <Stack key={wi} spacing="2px" sx={{ flexShrink: 0 }}>
              {column.map((level, di) => (
                <HeatmapCell key={di} level={level} />
              ))}
            </Stack>
          ))}
        </Stack>
      </Stack>
    </>
  )
}
